<template>
  <v-snackbar class="notification-request" v-model="showDialog" :timeout="-1" :multi-line="true" right bottom>
    <div class="snack-title mb-3">
      <v-icon left color="white">{{ icons.mdiBellRing }}</v-icon>
      <h3 class="subtitle-1 pl-2 pr-4">{{ $t('pushNotification.requestTitle') }}</h3>
    </div>
    <div class="snack-content">
      <p>
        {{ $t('pushNotification.requestDescription') }}
      </p>
      <p class="font-italic text-center mt-2" v-if="registrationFailed">{{ $t('errorMessages.default')}}</p>
    </div>
    <div class="action mt-2">
      <v-btn text color="white" @click="denyNotification()">{{ $t('pushNotification.requestDenyButtonText') }}</v-btn>
      <v-btn text color="white" @click="allowNotification()" :loading="pendingRegistration" :disabled="registrationFailed">{{ $t('pushNotification.requestAllowButtonText') }}</v-btn>
    </div>
    <button type="button" @click="close()" class="close">
      <v-icon color="white">{{ icons.mdiClose }}</v-icon>
    </button>
  </v-snackbar>
</template>

<script>
  /*
  * Firebase Messaging only works on Chrome, Firefox and Edge (iOS is not support!)
  */

  import {mdiBellRing, mdiClose} from '@mdi/js';
  import firebase from 'firebase/app'
  import firebaseMessaging from '@/firebase/firebase-messaging';
  import store, {storage} from '@/store';

  export default {
    name: 'PushNotificationRequest',
    data() {
      return {
        showDialog: false,
        pendingRegistration: false,
        registrationFailed: false,
        icons: {mdiBellRing, mdiClose}
      }
    },
    computed: {
      showPushNotification() {
        if (firebase.messaging.isSupported() && store.state.firebaseConfig && !(storage.getItem('denyNotification') == 1) && !(storage.getItem('fcmTokenSent') == 1)) {
          return this.$store.state.app.showPushNotification;
        }
        return false;
      },
      registrationState() {
        return this.$store.state.app.pushNotificationRegistrationState;
      }
    },
    methods: {
      close() {
        this.$store.dispatch('showPushNotificationRequest', false);
      },
      denyNotification() {
        storage.setItem('denyNotification', 1);
        this.close();
      },
      allowNotification() {
        this.$store.dispatch('pushNotificationRegistration', {mode: 'pending'});
        firebaseMessaging();
      },
      delayShowDialog() {
        setTimeout(() => {
          this.showDialog = true;
        }, 2000);
      }
    },
    watch: {
      showPushNotification: {
        immediate: true,
        handler(show) {
          if (show) {
            this.delayShowDialog();
          } else {
            this.showDialog = false;
          }
        }
      },
      registrationState(to) {
        if (to.mode === 'pending') {
          this.pendingRegistration = true;
        } else if (to.mode === 'success') {
          storage.setItem('fcmTokenSent', 1)
          setTimeout(() => {
            this.close(); // set delay to let user know something happens
          }, 600);
        } else if (to.mode === 'error') {
          this.pendingRegistration = false;
          this.registrationFailed = true;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .close {
    position: absolute;
    right: 4px;
    top: 4px;
    outline: none;
  }

  .notification-request {
    color: #fff;
    .snack-title {
      display: flex;
      align-items: center;
    }
    &::v-deep .v-snack__wrapper {
      max-width: 240px;
      position: relative;
    }
    &::v-deep .v-snack__content {
      flex-direction: column;
      align-items: flex-start;
    }
    &::v-deep .v-btn.v-size--default {
      font-size: 0.75rem;
    }
    &::v-deep .v-btn.v-btn--disabled{
      color: #FFFFFF !important;
      opacity: .3;
    }
    .action {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    p {
      margin: 0;
    }
  }

  @media (min-width: 768px) {
    .notification-request {
      bottom: auto;
      align-items: flex-start !important;
      &::v-deep .v-snack__wrapper {
        margin-right: auto;
        margin-left: 8px !important;
      }
    }
  }
  @media (min-width: 960px) {
    .notification-request {
      bottom: auto;
    }
  }
</style>
